<script setup>
defineProps({
    // { open: boolean, label: string } from useReachability()
    status: {
        type: Object,
        required: true,
    },
})
</script>

<template>
    <span class="inline-flex items-center gap-1.5">
        <span class="relative flex size-2 flex-none" aria-hidden="true">
            <span v-if="status.open" class="absolute inline-flex size-full rounded-full bg-green-400 opacity-75 motion-safe:animate-ping"></span>
            <span class="relative inline-flex size-2 rounded-full" :class="status.open ? 'bg-green-400' : 'bg-current opacity-40'"></span>
        </span>
        {{ status.label }}
    </span>
</template>
